import { Component, Inject } from "@angular/core";

import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import {  Store } from "@ngxs/store";



@Component({
  selector: 'documents-dialog',
  templateUrl: 'documents-dialog.html',
  styleUrls: ["./documents-dialog.scss"]
})
export class DocumentsDialog  {
  
  contextType : string;
  contextId : number;
  providerId : number;
  

  constructor(
    public dialogRef: MatDialogRef<DocumentsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store : Store
  )
  {
    console.log('data', data);
    this.contextType = data.contextType;
    this.contextId = data.contextId;
    this.providerId = data.providerId;
  }

  close() {
    this.dialogRef.close();
  }
}